import React, { Dispatch, SetStateAction, KeyboardEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { VerifiedAddress } from './addressVerificationTypes';

const SUGGESTION_CLASS = 'av__suggestion';
const SUBMITTED_ADDRESS = 'submitted';
const VERIFIED_ADDRESS = 'verified';

function SuggestionAddress(props: {
  verifiedAddress: VerifiedAddress;
  submittedAddress: VerifiedAddress;
  handleKeyPress: (
    event: KeyboardEvent<HTMLDivElement>,
    addressSelected: string
  ) => void;
  handleClick: (clickedAddress: string) => void;
  addressSelected: string;
  setShowAddressVerification: Dispatch<SetStateAction<boolean>>;
}) {
  const { verifiedAddress, submittedAddress, addressSelected } = props;
  const line1Diff = submittedAddress.primaryLine !== verifiedAddress.primaryLine
    ? SUGGESTION_CLASS
    : '';
  const line2Diff = submittedAddress.secondaryLine !== verifiedAddress.secondaryLine
    ? SUGGESTION_CLASS
    : '';
  const cityDiff = submittedAddress.city !== verifiedAddress.city ? SUGGESTION_CLASS : '';
  const stateDiff = submittedAddress.state !== verifiedAddress.state ? SUGGESTION_CLASS : '';
  const zipDiff = submittedAddress.zip !== verifiedAddress.zip ? SUGGESTION_CLASS : '';

  return (
    <div className="av__addresses">
      <div
        className={`av__address ${
          addressSelected === VERIFIED_ADDRESS
            ? 'av__address--selected'
            : ''
        }`}
        onClick={() => {
          props.handleClick(VERIFIED_ADDRESS);
        }}
        onKeyUp={(event: KeyboardEvent<HTMLDivElement>) => {
          props.handleKeyPress(event, VERIFIED_ADDRESS);
        }}
        role="button"
        tabIndex={0}
      >
        <div className="av__row">
          <div
            className={`av__checkbox ${
              addressSelected === VERIFIED_ADDRESS
                ? 'av__checkbox--checked'
                : ''
            }`}
          >
            {addressSelected === VERIFIED_ADDRESS && (
              <FontAwesomeIcon icon={faCheck} />
            )}
          </div>
          <div className="av__addresses-title">Suggested address:</div>
        </div>
        <div className="av__address-row">
          <span className={line1Diff}>{verifiedAddress.primaryLine}</span>
        </div>
        <div className="av__address-row">
          <span className={line2Diff}>
            {verifiedAddress.secondaryLine}
          </span>
        </div>
        <div className="av__address-row">
          <span className={cityDiff}>{verifiedAddress.city}</span>
          ,
          {' '}
          <span className={stateDiff}>{verifiedAddress.state}</span>
          {' '}
          <span className={zipDiff}>{verifiedAddress.zip}</span>
        </div>
      </div>
      {/* address as entered */}
      <div
        className={`av__address ${
          addressSelected === SUBMITTED_ADDRESS
            ? 'av__address--selected'
            : ''
        }`}
        onClick={() => {
          props.handleClick(SUBMITTED_ADDRESS);
        }}
        onKeyUp={(event: KeyboardEvent<HTMLDivElement>) => {
          props.handleKeyPress(event, SUBMITTED_ADDRESS);
        }}
        role="button"
        tabIndex={0}
      >
        <div className="av__row">
          <div
            className={`av__checkbox ${
              addressSelected === SUBMITTED_ADDRESS
                ? 'av__checkbox--checked'
                : ''
            }`}
          >
            {addressSelected === SUBMITTED_ADDRESS && (
              <FontAwesomeIcon icon={faCheck} />
            )}
          </div>
          <div className="av__addresses-title">Address as entered:</div>
        </div>
        <div className="av__address-row">
          {submittedAddress.primaryLine}
        </div>
        <div className="av__address-row">
          {`${submittedAddress.city}${submittedAddress.state ? `, ${submittedAddress.state}` : ''} ${submittedAddress.zip}`}
        </div>
        <button
          className="av__edit-button"
          type="button"
          onClick={() => {
            props.setShowAddressVerification(false);
          }}
        >
          EDIT ADDRESS
        </button>
      </div>
    </div>
  );
}

export default SuggestionAddress;
